var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCnWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "174px",
    height: "42px",
    viewBox: "0 0 174 42",
    style: {
      enableBackground: "new 0 0 174 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.05,33.81c0.34-0.34,0.76-0.52,1.28-0.52c0.7,0,1.2,0.23,1.53,0.69c0.18,0.26,0.27,0.52,0.29,0.78h-0.87 c-0.06-0.2-0.13-0.35-0.21-0.45c-0.16-0.18-0.39-0.27-0.69-0.27c-0.31,0-0.56,0.13-0.74,0.38c-0.18,0.26-0.27,0.62-0.27,1.09 c0,0.47,0.09,0.82,0.28,1.05c0.19,0.23,0.43,0.35,0.72,0.35c0.3,0,0.53-0.1,0.68-0.3c0.09-0.11,0.16-0.27,0.22-0.49h0.87 c-0.07,0.45-0.27,0.82-0.57,1.11c-0.31,0.29-0.7,0.43-1.18,0.43c-0.6,0-1.06-0.19-1.4-0.58c-0.34-0.39-0.51-0.92-0.51-1.59 C42.47,34.77,42.66,34.2,43.05,33.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.65,37.55v-4.18h0.87v1.6h1.63v-1.6h0.87v4.18h-0.87v-1.86h-1.63v1.86H46.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.66,33.37h0.89v2.57c0,0.29,0.03,0.5,0.1,0.63c0.11,0.23,0.34,0.35,0.69,0.35c0.35,0,0.58-0.12,0.69-0.35 c0.07-0.13,0.1-0.34,0.1-0.63v-2.57h0.89v2.57c0,0.45-0.07,0.79-0.21,1.04c-0.26,0.45-0.75,0.68-1.48,0.68 c-0.73,0-1.22-0.23-1.48-0.68c-0.14-0.25-0.21-0.59-0.21-1.04V33.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.66,33.37h0.91l1.66,2.91v-2.91h0.81v4.18h-0.87l-1.71-2.97v2.97h-0.81V33.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.48,34.68c-0.07-0.29-0.23-0.49-0.48-0.6c-0.14-0.06-0.3-0.09-0.48-0.09c-0.34,0-0.61,0.13-0.83,0.38 c-0.22,0.25-0.32,0.63-0.32,1.15c0,0.51,0.12,0.88,0.35,1.09c0.23,0.21,0.5,0.32,0.8,0.32c0.29,0,0.53-0.08,0.72-0.25 c0.19-0.17,0.3-0.39,0.35-0.66h-0.97v-0.7h1.75v2.24h-0.58l-0.09-0.52c-0.17,0.2-0.32,0.34-0.45,0.42 c-0.23,0.14-0.52,0.21-0.85,0.21c-0.56,0-1.01-0.19-1.36-0.57c-0.37-0.38-0.55-0.91-0.55-1.58c0-0.68,0.19-1.22,0.56-1.63 c0.37-0.41,0.87-0.61,1.48-0.61c0.53,0,0.96,0.13,1.28,0.4c0.32,0.27,0.51,0.61,0.56,1.01H61.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.4,33.81c0.34-0.34,0.77-0.52,1.28-0.52c0.7,0,1.2,0.23,1.53,0.69c0.18,0.26,0.27,0.52,0.29,0.78h-0.87 c-0.06-0.2-0.13-0.35-0.21-0.45c-0.16-0.18-0.39-0.27-0.69-0.27c-0.31,0-0.56,0.13-0.74,0.38c-0.18,0.26-0.27,0.62-0.27,1.09 c0,0.47,0.09,0.82,0.28,1.05c0.19,0.23,0.43,0.35,0.72,0.35c0.3,0,0.53-0.1,0.68-0.3c0.09-0.11,0.16-0.27,0.22-0.49h0.87 c-0.07,0.45-0.27,0.82-0.57,1.11c-0.31,0.29-0.7,0.43-1.18,0.43c-0.59,0-1.06-0.19-1.4-0.58c-0.34-0.39-0.51-0.92-0.51-1.59 C62.82,34.77,63.01,34.2,63.4,33.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67,37.55v-4.18h0.87v1.6h1.63v-1.6h0.87v4.18H69.5v-1.86h-1.63v1.86H67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.06,34.12h-2.17V35h1.99v0.73h-1.99v1.07h2.27v0.75h-3.13v-4.18h3.02V34.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.92,37.18c-0.32,0.33-0.78,0.49-1.38,0.49c-0.6,0-1.06-0.16-1.38-0.49c-0.43-0.4-0.64-0.97-0.64-1.73 c0-0.77,0.21-1.34,0.64-1.73c0.32-0.32,0.78-0.49,1.38-0.49c0.6,0,1.06,0.16,1.38,0.49c0.42,0.38,0.64,0.96,0.64,1.73 C78.56,36.21,78.35,36.78,77.92,37.18z M77.38,36.54c0.2-0.25,0.31-0.62,0.31-1.08c0-0.47-0.1-0.83-0.31-1.08 c-0.21-0.26-0.48-0.38-0.83-0.38c-0.35,0-0.63,0.13-0.84,0.38c-0.21,0.25-0.31,0.62-0.31,1.08c0,0.47,0.1,0.83,0.31,1.08 c0.21,0.25,0.49,0.38,0.84,0.38C76.9,36.92,77.18,36.79,77.38,36.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.02,33.37h0.91l1.66,2.91v-2.91h0.81v4.18h-0.87l-1.71-2.97v2.97h-0.81V33.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.84,34.68c-0.07-0.29-0.23-0.49-0.48-0.6c-0.14-0.06-0.3-0.09-0.48-0.09c-0.34,0-0.61,0.13-0.83,0.38 c-0.22,0.25-0.32,0.63-0.32,1.15c0,0.51,0.12,0.88,0.35,1.09c0.23,0.21,0.5,0.32,0.8,0.32c0.29,0,0.53-0.08,0.72-0.25 c0.19-0.17,0.3-0.39,0.35-0.66h-0.97v-0.7h1.75v2.24h-0.58l-0.09-0.52c-0.17,0.2-0.32,0.34-0.45,0.42 c-0.23,0.14-0.52,0.21-0.85,0.21c-0.55,0-1.01-0.19-1.36-0.57c-0.37-0.38-0.55-0.91-0.55-1.58c0-0.68,0.19-1.22,0.56-1.63 c0.37-0.41,0.87-0.61,1.48-0.61c0.53,0,0.96,0.13,1.28,0.4c0.32,0.27,0.51,0.61,0.56,1.01H85.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.35,33.37h0.91l1.66,2.91v-2.91h0.81v4.18h-0.87l-1.71-2.97v2.97h-0.81V33.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.56,33.37h0.99l1.48,4.18h-0.95l-0.27-0.85h-1.55l-0.28,0.85h-0.91L92.56,33.37z M92.5,35.97h1.07 l-0.53-1.65L92.5,35.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.17,33.37h1.26v4.18h-0.81v-2.83c0-0.08,0-0.2,0-0.34c0-0.15,0-0.26,0-0.34l-0.8,3.51h-0.86l-0.79-3.51 c0,0.08,0,0.19,0,0.34c0,0.15,0,0.26,0,0.34v2.83h-0.81v-4.18h1.27l0.77,3.29L98.17,33.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.47,33.46c0.29,0.1,0.53,0.27,0.71,0.53c0.15,0.21,0.25,0.43,0.3,0.67c0.05,0.24,0.08,0.47,0.08,0.69 c0,0.56-0.11,1.03-0.34,1.41c-0.3,0.52-0.77,0.78-1.4,0.78h-1.81v-4.18h1.81C102.08,33.37,102.3,33.4,102.47,33.46z  M100.87,34.09v2.73h0.81c0.41,0,0.7-0.2,0.86-0.61c0.09-0.22,0.13-0.49,0.13-0.8c0-0.43-0.07-0.75-0.2-0.98 c-0.13-0.23-0.4-0.34-0.8-0.34H100.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.25,37.18c-0.32,0.33-0.78,0.49-1.38,0.49c-0.6,0-1.06-0.16-1.38-0.49c-0.43-0.4-0.64-0.97-0.64-1.73 c0-0.77,0.21-1.34,0.64-1.73c0.32-0.32,0.78-0.49,1.38-0.49c0.6,0,1.06,0.16,1.38,0.49c0.42,0.38,0.63,0.96,0.63,1.73 C107.89,36.21,107.68,36.78,107.25,37.18z M106.71,36.54c0.2-0.25,0.31-0.62,0.31-1.08c0-0.47-0.1-0.83-0.31-1.08 c-0.21-0.26-0.48-0.38-0.83-0.38c-0.35,0-0.63,0.13-0.84,0.38c-0.21,0.25-0.31,0.62-0.31,1.08c0,0.47,0.1,0.83,0.31,1.08 c0.21,0.25,0.49,0.38,0.84,0.38C106.23,36.92,106.51,36.79,106.71,36.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113,37.18c-0.32,0.33-0.78,0.49-1.38,0.49c-0.6,0-1.06-0.16-1.38-0.49c-0.43-0.4-0.64-0.97-0.64-1.73 c0-0.77,0.21-1.34,0.64-1.73c0.32-0.32,0.78-0.49,1.38-0.49c0.6,0,1.06,0.16,1.38,0.49c0.42,0.38,0.64,0.96,0.64,1.73 C113.63,36.21,113.42,36.78,113,37.18z M112.46,36.54c0.21-0.25,0.31-0.62,0.31-1.08c0-0.47-0.1-0.83-0.31-1.08 c-0.21-0.26-0.48-0.38-0.83-0.38c-0.35,0-0.63,0.13-0.84,0.38c-0.21,0.25-0.31,0.62-0.31,1.08c0,0.47,0.1,0.83,0.31,1.08 c0.21,0.25,0.49,0.38,0.84,0.38C111.98,36.92,112.25,36.79,112.46,36.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.09,33.37h2.99v0.74h-2.12v0.96h1.85v0.73h-1.85v1.75h-0.87V33.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.45,33.37h2.99v0.74h-2.12v0.96h1.85v0.73h-1.85v1.75h-0.87V33.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.6,37.55h-0.87v-4.18h0.87V37.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.63,33.81c0.34-0.34,0.76-0.52,1.28-0.52c0.7,0,1.2,0.23,1.53,0.69c0.18,0.26,0.27,0.52,0.29,0.78h-0.87 c-0.06-0.2-0.13-0.35-0.21-0.45c-0.16-0.18-0.39-0.27-0.69-0.27c-0.31,0-0.56,0.13-0.74,0.38c-0.18,0.26-0.27,0.62-0.27,1.09 c0,0.47,0.09,0.82,0.28,1.05c0.19,0.23,0.43,0.35,0.72,0.35c0.3,0,0.53-0.1,0.68-0.3c0.09-0.11,0.16-0.27,0.22-0.49h0.87 c-0.07,0.45-0.27,0.82-0.57,1.11c-0.31,0.29-0.7,0.43-1.18,0.43c-0.6,0-1.06-0.19-1.4-0.58c-0.34-0.39-0.51-0.92-0.51-1.59 C122.05,34.77,122.24,34.2,122.63,33.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.28,34.12h-2.17V35h1.99v0.73h-1.99v1.07h2.27v0.75h-3.13v-4.18h3.02V34.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.03,37.18c-0.32,0.33-0.78,0.49-1.38,0.49c-0.6,0-1.06-0.16-1.38-0.49c-0.42-0.4-0.64-0.97-0.64-1.73 c0-0.77,0.21-1.34,0.64-1.73c0.32-0.32,0.78-0.49,1.38-0.49c0.6,0,1.06,0.16,1.38,0.49c0.42,0.38,0.63,0.96,0.63,1.73 C135.66,36.21,135.45,36.78,135.03,37.18z M134.49,36.54c0.21-0.25,0.31-0.62,0.31-1.08c0-0.47-0.1-0.83-0.31-1.08 c-0.21-0.26-0.48-0.38-0.83-0.38c-0.35,0-0.63,0.13-0.84,0.38c-0.21,0.25-0.31,0.62-0.31,1.08c0,0.47,0.1,0.83,0.31,1.08 c0.21,0.25,0.49,0.38,0.84,0.38C134,36.92,134.28,36.79,134.49,36.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.12,33.37h2.99v0.74h-2.12v0.96h1.85v0.73h-1.85v1.75h-0.87V33.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.41,34.12h-2.17V35h1.99v0.73h-1.99v1.07h2.27v0.75h-3.13v-4.18h3.02V34.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.5,33.46c0.29,0.1,0.53,0.27,0.71,0.53c0.15,0.21,0.25,0.43,0.3,0.67c0.05,0.24,0.08,0.47,0.08,0.69 c0,0.56-0.11,1.03-0.34,1.41c-0.3,0.52-0.77,0.78-1.4,0.78h-1.81v-4.18h1.81C147.11,33.37,147.32,33.4,147.5,33.46z M145.9,34.09 v2.73h0.81c0.41,0,0.7-0.2,0.86-0.61c0.09-0.22,0.13-0.49,0.13-0.8c0-0.43-0.07-0.75-0.2-0.98c-0.13-0.23-0.4-0.34-0.8-0.34 H145.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.05,33.37h0.89v2.57c0,0.29,0.03,0.5,0.1,0.63c0.11,0.23,0.34,0.35,0.69,0.35 c0.35,0,0.58-0.12,0.69-0.35c0.07-0.13,0.1-0.34,0.1-0.63v-2.57h0.89v2.57c0,0.45-0.07,0.79-0.21,1.04 c-0.26,0.45-0.75,0.68-1.48,0.68c-0.73,0-1.22-0.23-1.48-0.68c-0.14-0.25-0.21-0.59-0.21-1.04V33.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.46,33.81c0.34-0.34,0.77-0.52,1.28-0.52c0.7,0,1.2,0.23,1.53,0.69c0.18,0.26,0.27,0.52,0.29,0.78h-0.87 c-0.06-0.2-0.13-0.35-0.21-0.45c-0.16-0.18-0.39-0.27-0.69-0.27c-0.31,0-0.56,0.13-0.74,0.38c-0.18,0.26-0.27,0.62-0.27,1.09 c0,0.47,0.09,0.82,0.28,1.05c0.19,0.23,0.43,0.35,0.72,0.35c0.3,0,0.53-0.1,0.68-0.3c0.09-0.11,0.16-0.27,0.22-0.49h0.87 c-0.07,0.45-0.27,0.82-0.57,1.11c-0.31,0.29-0.7,0.43-1.18,0.43c-0.6,0-1.06-0.19-1.4-0.58c-0.34-0.39-0.51-0.92-0.51-1.59 C152.88,34.77,153.07,34.2,153.46,33.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.26,33.37h0.99l1.48,4.18h-0.95l-0.27-0.85h-1.55l-0.28,0.85h-0.91L158.26,33.37z M158.2,35.97h1.07 l-0.53-1.65L158.2,35.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.69,33.37v0.74h-1.26v3.44h-0.88v-3.44h-1.26v-0.74H163.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.78,37.55h-0.87v-4.18h0.87V37.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.64,37.18c-0.32,0.33-0.78,0.49-1.37,0.49c-0.6,0-1.06-0.16-1.38-0.49c-0.42-0.4-0.64-0.97-0.64-1.73 c0-0.77,0.21-1.34,0.64-1.73c0.32-0.32,0.78-0.49,1.38-0.49c0.6,0,1.06,0.16,1.37,0.49c0.42,0.38,0.64,0.96,0.64,1.73 C169.27,36.21,169.06,36.78,168.64,37.18z M168.1,36.54c0.21-0.25,0.31-0.62,0.31-1.08c0-0.47-0.1-0.83-0.31-1.08 c-0.2-0.26-0.48-0.38-0.83-0.38c-0.35,0-0.63,0.13-0.84,0.38c-0.21,0.25-0.31,0.62-0.31,1.08c0,0.47,0.1,0.83,0.31,1.08 c0.21,0.25,0.49,0.38,0.84,0.38C167.62,36.92,167.89,36.79,168.1,36.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.73,33.37h0.91l1.66,2.91v-2.91h0.81v4.18h-0.87l-1.71-2.97v2.97h-0.81V33.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.05,1.82C28.2,0,25.53-0.55,23.06,0.6c-2.46,1.14-3.78,3.54-2.94,5.36c0.84,1.82,3.52,2.37,5.99,1.22 C28.58,6.04,29.89,3.64,29.05,1.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.34,37.68c0.86-0.31-2.14,1.13-2.91,1.53c-2.37,1.24-5.21,1.92-7.4,2.39c-4.39,0.94-8.17,0.27-10.31-2.22 c-4.27-4.97-0.34-15.35,8.79-23.18c4.56-3.92,9.56-6.45,13.94-7.39c2.2-0.47,4.24-0.54,6-0.18c0,0,4.93,0.82,2.53,6.87 c0,0-6.27,13.63-23.9,21.14c0,0,11.31-7.93,16.76-17.83c0,0,4.33-7.13-2.29-7.01c0,0-2.82-0.02-7.17,2.52 c-3.84,2.11-8.69,5.95-11.33,12.6c0,0-4.55,10.86,8.06,12.01C13.11,38.94,17.67,39.35,22.34,37.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.34,18.66c-0.71,1.05-2.09,3.06-3.48,4.81c1.61,0.13,3.2,0.56,2.07,3.71c0,0-1.87,4.83-7.32,9.72 c0,0,9.21-5.36,12.51-12.4C36.13,24.51,39.98,17.07,32.34,18.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 73.11,
    y: 15.59,
    className: "st0",
    width: 3.41,
    height: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.29,14.02c0,0-0.36,3.89-4.62,5.53l1.11,1.42c0,0,5.03-1.56,5.83-6.66L66.29,14.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.01,14.02c0,0,0.36,3.89,4.62,5.53l-1.11,1.42c0,0-5.03-1.56-5.83-6.66L69.01,14.02z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.34,
    y: 11.43,
    className: "st0",
    width: 2.58,
    height: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.21,13.56c0,0.47-0.38,0.85-0.85,0.85h-9.48c-0.47,0-0.85-0.38-0.85-0.85l0,0c0-0.47,0.38-0.85,0.85-0.85 h9.48C72.83,12.71,73.21,13.09,73.21,13.56L73.21,13.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.57,26.03c0,0.66-0.54,0.38-1.2,0.38l0,0c-0.66,0-1.2-0.54-1.2-1.2v-12.6c0-0.66,0.54-1.2,1.2-1.2l0,0 c0.66,0,1.2,0.54,1.2,1.2V26.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.57,25.91c0,2.37-3.11,4.3-6.94,4.3c-3.84,0-6.94-1.92-6.94-4.3c0-2.37,3.11-4.3,6.94-4.3 C74.46,21.61,77.57,23.54,77.57,25.91z M70.62,23.2c-2.39,0-4.33,1.21-4.33,2.71c0,1.5,1.94,2.71,4.33,2.71 c2.39,0,4.33-1.21,4.33-2.71C74.95,24.42,73.01,23.2,70.62,23.2z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 168.82,
    y: 15.59,
    className: "st0",
    width: 3.41,
    height: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162,14.02c0,0-0.36,3.89-4.62,5.53l1.11,1.42c0,0,5.03-1.56,5.83-6.66L162,14.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.72,14.02c0,0,0.36,3.89,4.62,5.53l-1.11,1.42c0,0-5.03-1.56-5.83-6.66L164.72,14.02z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.05,
    y: 11.43,
    className: "st0",
    width: 2.58,
    height: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.92,13.56c0,0.47-0.38,0.85-0.85,0.85h-9.48c-0.47,0-0.85-0.38-0.85-0.85l0,0c0-0.47,0.38-0.85,0.85-0.85 h9.48C168.54,12.71,168.92,13.09,168.92,13.56L168.92,13.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.28,26.03c0,0.66-0.54,0.38-1.2,0.38l0,0c-0.66,0-1.2-0.54-1.2-1.2v-12.6c0-0.66,0.54-1.2,1.2-1.2l0,0 c0.66,0,1.2,0.54,1.2,1.2V26.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.28,25.91c0,2.37-3.11,4.3-6.94,4.3c-3.84,0-6.95-1.92-6.95-4.3c0-2.37,3.11-4.3,6.95-4.3 C170.17,21.61,173.28,23.54,173.28,25.91z M166.33,23.2c-2.39,0-4.33,1.21-4.33,2.71c0,1.5,1.94,2.71,4.33,2.71 c2.39,0,4.33-1.21,4.33-2.71C170.66,24.42,168.72,23.2,166.33,23.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.68,
    y: 15.05,
    className: "st0",
    width: 3.41,
    height: 1.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.41,29.04c0,0.47-0.38,0.85-0.85,0.85H83.76c-0.47,0-0.85-0.38-0.85-0.85l0,0c0-0.47,0.38-0.85,0.85-0.85 h10.79C95.03,28.19,95.41,28.57,95.41,29.04L95.41,29.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.83,19.5c0,0.47-0.38,0.85-0.85,0.85h-8.36c-0.47,0-0.85-0.38-0.85-0.85l0,0c0-0.47,0.38-0.85,0.85-0.85 h8.36C91.45,18.64,91.83,19.02,91.83,19.5L91.83,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.91,21.41v-8.78c0-0.66-0.54-1.2-1.2-1.2c-0.66,0-1.2,0.54-1.2,1.2v8.78H95.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.91,29.89v-6.52c0-0.49-0.54-0.89-1.2-0.89c-0.66,0-1.2,0.4-1.2,0.89v6.52H95.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.36,19.02v-5.97c0-0.66-0.54-1.2-1.2-1.2c-0.66,0-1.2,0.54-1.2,1.2v5.97H83.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.35,18.64h1.68c0,0,1.16-0.02,1.74-0.76l0.19,1.42c0,0-1.07,1.13-3.49,1.06"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.21,
    y: 22.42,
    className: "st0",
    width: 13.71,
    height: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.87,18.9c0,0.8-0.65,1.45-1.45,1.45c-0.8,0-1.45-0.65-1.45-1.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.11,18.62c-0.42,0-0.76-0.34-0.76-0.76l-0.62,0.23l0.02,1.06l1.26,0.14L84.11,18.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.37,28.19c-0.42,0-0.76-0.34-0.76-0.76l-0.62,0.23l0.02,1.06l1.26,0.14L85.37,28.19z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "84.61,28.54 84.61,22.42 82.21,22.42 82.21,28.49  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.21,28.43c0,0.8,0.65,1.45,1.45,1.45c0.8,0,1.45-0.65,1.45-1.45l-1.61-0.39L82.21,28.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.9,24.8c0,0.47-0.38,0.85-0.85,0.85H100.5c-0.47,0-0.85-0.38-0.85-0.85l0,0c0-0.47,0.38-0.85,0.85-0.85 h15.55C116.52,23.95,116.9,24.33,116.9,24.8L116.9,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.54,12.71c0,0.47-0.38,0.85-0.85,0.85h-12.37c-0.47,0-0.85-0.38-0.85-0.85l0,0 c0-0.47,0.38-0.85,0.85-0.85h12.37C115.15,11.86,115.54,12.24,115.54,12.71L115.54,12.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.54,18.98c0,0.47-0.37,0.85-0.82,0.85H102.8c-0.45,0-0.82-0.38-0.82-0.85l0,0 c0-0.47,0.37-0.85,0.82-0.85h11.91C115.17,18.12,115.54,18.51,115.54,18.98L115.54,18.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.5,25.01v-2.87c0-0.66-0.55-1.2-1.23-1.2c-0.68,0-1.23,0.54-1.23,1.2v2.87H109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.33,18.13c-0.42,0-0.76-0.34-0.76-0.76l-0.62,0.23l0.02,1.06l1.26,0.14L104.33,18.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.18,18.37c0,0.8,0.65,1.45,1.45,1.45c0.8,0,1.45-0.65,1.45-1.45l-1.61-0.39L101.18,18.37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "103.57,18.68 103.57,11.86 101.18,11.86 101.18,18.42  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.24,24.86c0,0.47-0.38,0.85-0.85,0.85h-15.44c-0.47,0-0.85-0.38-0.85-0.85l0,0 c0-0.47,0.38-0.85,0.85-0.85h15.44C135.86,24.01,136.24,24.39,136.24,24.86L136.24,24.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.99,24.04v-4.6c0-0.66-0.54-1.2-1.2-1.2c-0.66,0-1.2,0.54-1.2,1.2v4.6H129.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.2,24.04v-4.6c0-0.66-0.54-1.2-1.2-1.2c-0.66,0-1.2,0.54-1.2,1.2v4.6H125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.37,19.22v2.49c0,0-0.11,1.96-0.88,2.57l1.75-0.2c0,0,1.51-1.07,1.51-4.86L132.37,19.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.59,13.56c0.42,0,0.76,0.34,0.76,0.76l0.62-0.23l-0.02-1.06l-1.26-0.14L131.59,13.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.75,13.31c0-0.8-0.65-1.45-1.45-1.45c-0.8,0-1.45,0.65-1.45,1.45l1.61,0.39L134.75,13.31z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "132.35,13.37 132.35,19.3 134.75,19.3 134.75,13.31  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.33,11.86h-11.99c-0.47,0-0.85,0.38-0.85,0.85c0,0.47,0.38,0.85,0.85,0.85h11.99V11.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.52,21.06c0,0.47-0.38,0.85-0.85,0.85h-15.44c-0.47,0-0.85-0.38-0.85-0.85l0,0 c0-0.47,0.38-0.85,0.85-0.85h15.44C155.14,20.2,155.52,20.58,155.52,21.06L155.52,21.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.95,15.28c0,2.23-3.11,4.05-6.95,4.05c-3.84,0-6.95-1.81-6.95-4.05c0-2.23,3.11-4.05,6.95-4.05 C150.84,11.23,153.95,13.04,153.95,15.28z M147,12.72c-2.39,0-4.33,1.14-4.33,2.55s1.94,2.55,4.33,2.55 c2.39,0,4.33-1.14,4.33-2.55S149.39,12.72,147,12.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.35,24.69v-3.18c0-0.66-0.54-1.2-1.2-1.2c-0.66,0-1.2,0.54-1.2,1.2v3.18H145.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.28,24.69v-3.18c0-0.66-0.54-1.2-1.2-1.2c-0.66,0-1.2,0.54-1.2,1.2v3.18H151.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.11,25.52c0.42,0,0.76,0.34,0.76,0.76l0.62-0.23l-0.02-1.06l-1.26-0.14L151.11,25.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.25,25.25c0-0.8-0.65-1.45-1.45-1.45c-0.8,0-1.32,0.65-1.32,1.45l1.48,0.39L154.25,25.25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.86,
    y: 25.23,
    className: "st0",
    width: 2.4,
    height: 4.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.76,23.81H140.5c-0.47,0-0.85,0.38-0.85,0.85s0.38,0.85,0.85,0.85h12.26V23.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.3,
    y: 11.43,
    className: "st0",
    width: 2.62,
    height: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.3,
    y: 21,
    className: "st0",
    width: 2.62,
    height: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.02,13.56c0,0.47-0.39,0.85-0.88,0.85H44.11c-0.48,0-0.88-0.38-0.88-0.85l0,0c0-0.47,0.39-0.85,0.88-0.85 h13.04C57.63,12.71,58.02,13.09,58.02,13.56L58.02,13.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.26,20.82c0,0.47-0.38,0.85-0.85,0.85H42.85c-0.47,0-0.85-0.38-0.85-0.85l0,0c0-0.47,0.38-0.85,0.85-0.85 H58.4C58.88,19.97,59.26,20.35,59.26,20.82L59.26,20.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.89,12.97c0,0,0.25,5.91-8.55,5.91l-0.67-1.51c0,0,7.05,0.04,6.61-4.64L51.89,12.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.41,12.97c0,0-0.25,5.91,8.55,5.91l0.67-1.51c0,0-7.05,0.04-6.61-4.64L49.41,12.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.84,26.33c0,2.1-3.22,3.8-7.19,3.8c-3.97,0-7.2-1.7-7.2-3.8c0-2.1,3.22-3.8,7.2-3.8 C54.62,22.53,57.84,24.23,57.84,26.33z M50.65,23.93c-2.46,0-4.45,1.07-4.45,2.39c0,1.32,1.99,2.39,4.45,2.39 c2.46,0,4.45-1.07,4.45-2.39C55.1,25,53.11,23.93,50.65,23.93z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCnWh);
export default __webpack_public_path__ + "static/media/logo_cn_wh.33ac8bda20d9c848b1899e104641ab4a.svg";
export { ForwardRef as ReactComponent };